import PropTypes from 'prop-types';
import React from 'react';
import { Transition, TransitionGroup } from 'react-transition-group';

import { Animation } from './styled-components';

const PageTransition = ({ id, children }) => (
  <TransitionGroup>
    <Transition key={id} timeout={150} exit={false}>
      {state => <Animation state={state}>{children}</Animation>}
    </Transition>
  </TransitionGroup>
);

PageTransition.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default PageTransition;
